export const SIDEBAR_WIDTH = 125
export const PRIMARY_COLOR = '#0d1b2a'